const $$splitComponentImporter = () => import('/src/src/routes/_cms/cms/manage/events/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_cms/cms/manage/events/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Event Drafts",
      description: "Page title for CMS event drafts list"
    })
  }
});